export var DEPLOY_DATE = new Date('2025-12-19T16:05:49+0000');
